enum Language {
    NONE = 'NONE',
    UNKNOWN = 'UNKNOWN',
    ENGLISH = 'en',
    JAPANESE = 'jp',
    GERMAN = 'de',
    ITALIAN = 'it',
    FRENCH = 'fr',
    SPANISH = 'es'
}

export default Language;